import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { SecondaryButton } from "../../../../../components/Buttons/components/ActionButton";
import { ResourceName, ResourceVariant } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import type { NoneOwnProps } from "../../../../../core/types";

export const AddVirtualButton: FC<NoneOwnProps> = () => {
    const navigate = useNavigate();
    const onClick = () =>
        navigate(
            `${BASE_PATH}/${ResourceName.CONTRACTS}/${ResourceVariant.VIRTUAL}/${FORM_ACTION.CREATE}?discriminator=VIRTUAL&service=true`,
        );

    return (
        <SecondaryButton onClick={onClick} disabled={false}>
            {i18n.t("contract.add.virtual")}
        </SecondaryButton>
    );
};
